import "@babel/polyfill";

import React from 'react';
import isIe from'./utils/isIe';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import './semantic/dist/semantic.min.css';

import {Provider} from 'react-redux';
import store from './store';
import './populateState';

import {version} from '../package';


try {
	window.Raven.config('https://c1a82821e8d34861977ca8d1d70d9cf1@sentry.io/1236031', {
		release: version
	})
		.install();
} catch (e) {
	console.log('Raven not on window, NO ERROR REPORTING 4 U >;(');
}

ReactDOM.render(
	<Provider store={store}>
		<App/>
	</Provider>,
	document.getElementById('root')
);
registerServiceWorker();

console.log('Is it all over?... Did we load?');
console.log(`ConFuzzled 2019 theme v${version} is a-go-go`);


try {
	if (isIe()) {
		document.body.classList.add('is-ie');
	}
} catch(e) {
	console.error('error parsing IE guff', e);
}



// WEBPACK FOOTER //
// ./src/index.js